import React from "react";
import { Route } from "react-router-dom";
import Vibes from "../pages/Vibes";

export const vibesRoutes = <Route path="/vibes" element={<Vibes />} />;
